<div class="advizeo-toolbar toolbar-right small-margin">
    <ui-icon-button iconName="cancel" size="small" (click)="close.emit(undefined)" />
</div>

<!-- STEP 0: Choice of tile type -->
@if (currentStep === 0) {
    <div class="step-content">
        <div class="title">
            @if (!editMode) {
                <h2>{{ steps[0].title | translate }}</h2>
            } @else {
                <h2>{{ steps[0].titleEdit | translate }}</h2>
            }
            <progress class="progress-select" max="100" form="form-id" [value]="steps[0].percentage">{{ steps[0].percentage }}%</progress>
        </div>
        <div class="ipe-type">
            @for (option of steps[0].options; track option) {
                <div class="img-select" (click)="typeChoice(option)">
                    <div class="image-text-select">
                        <img class="image-select" [src]="option.image" />
                        <p>{{ option.label | translate }}</p>
                    </div>
                </div>
            }
        </div>
    </div>
}

<!-- STEP 1: Choice of consumption -->
@if (currentStep === 1) {
    <div class="step-content">
        <div class="title">
            <h2>{{ steps[1].title | translate }}</h2>
            <progress class="progress-select" max="100" form="form-id" [value]="steps[1].percentage">{{ steps[1].percentage }}%</progress>
        </div>
        <div class="card-select">
            <ui-form-field [label]="'IPE.IPE_STEP_TITLE' | translate">
                <input advizeoInput type="text" [required]="true" [(ngModel)]="tile.name" />
            </ui-form-field>
        </div>
        <div class="card-select">
            <div
                class="grid-container grid-1"
                advizeoBooleanControlGroup
                [ngModel]="tile.description.indicator"
                (ngModelChange)="change(1, $event)"
            >
                @for (option of steps[1].options; track option) {
                    <ui-radio-button
                        controlValueAccessorInterop
                        [advizeoBooleanControlValue]="option.value"
                        [label]="option.label | translate"
                    />
                }
            </div>
        </div>
        @if (tile.description.indicator === CUSTOMCONSTANT && tile.description.customIndicator) {
            <div class="card-select">
                <div class="grid-container grid-1">
                    <ui-form-field [label]="'IPE.IPE_STEP_NAME' | translate">
                        <input
                            advizeoInput
                            type="text"
                            [ngModel]="tile.description.customIndicator.label"
                            [required]="true"
                            (ngModelChange)="indicatorChange('label', $event)"
                        />
                    </ui-form-field>
                    <ui-form-field [label]="'IPE.IPE_STEP_VALUE' | translate">
                        <input
                            advizeoInput
                            type="number"
                            [ngModel]="tile.description.customIndicator.value"
                            [required]="true"
                            (ngModelChange)="indicatorChange('value', $event)"
                        />
                    </ui-form-field>
                </div>
            </div>
        }
        <div class="card-select">
            <div
                class="grid-container grid-1"
                advizeoBooleanControlGroup
                [ngModel]="tile.description.energyType"
                (ngModelChange)="change(2, $event)"
            >
                @for (option of steps[2].options; track option) {
                    <ui-radio-button
                        controlValueAccessorInterop
                        [advizeoBooleanControlValue]="option.value"
                        [label]="option.label | translate"
                    />
                }
            </div>
        </div>
    </div>
}

<!-- STEP 2: Choice of the energy type -->
@if (currentStep === 2) {
    <div class="step-content">
        <div class="title">
            <h2>{{ steps[3].title | translate }}</h2>
            <progress class="progress-select" max="100" form="form-id" [value]="steps[3].percentage">{{ steps[3].percentage }}%</progress>
        </div>
        <div class="card-select">
            <div
                class="grid-container grid-1"
                advizeoBooleanControlGroup
                [multiple]="true"
                [ngModel]="tile.description.universeIds"
                (ngModelChange)="change(3, $event)"
            >
                @for (option of steps[3].options; track option) {
                    <ui-checkbox [advizeoBooleanControlValue]="option.value" [label]="option.label | translate" />
                }
            </div>
        </div>
    </div>
}

<!-- STEP 3: Choice of range number/color -->
@if (currentStep === 3) {
    <div class="step-content">
        <!-- Title and preview -->
        <div class="title">
            <h2>{{ steps[4].title | translate }}</h2>
            <progress class="progress-select" max="100" form="form-id" [value]="steps[4].percentage">{{ steps[4].percentage }}%</progress>
        </div>
        <div class="card-select">
            @if (needsValuePreview(tile)) {
                <tile-ipe-value-sub-component [forceBinding]="forceBinding" [tileData]="tile" [hasTileAdminOption]="false" />
            }
            @if (needsGaugePreview(tile)) {
                <tile-ipe-gauge-sub-component [forceBinding]="forceBinding" [tileData]="tile" [hasTileAdminOption]="false" />
            }
        </div>
        <!-- Select range -->
        <div class="card-select">
            <div
                class="grid-container grid-1"
                advizeoBooleanControlGroup
                [ngModel]="rangeChoicesSelected"
                (ngModelChange)="rangeTypeChange($event)"
            >
                @for (option of steps[4].options; track option) {
                    <ui-radio-button
                        controlValueAccessorInterop
                        [advizeoBooleanControlValue]="option.value"
                        [label]="option.label | translate"
                    />
                }
            </div>
        </div>
        <!-- Custom range -->
        @if (rangeChoicesSelected === this.rangeChoices.customRanges) {
            <div class="card-select">
                @for (option of tile.description.ranges; track option) {
                    <div class="option-select">
                        <span>
                            <input
                                name="start"
                                class="tild-color"
                                type="color"
                                [style.background-color]="option.color"
                                [(ngModel)]="option.color"
                                (change)="changeChart()"
                            />
                        </span>
                        <span class="tild-text">{{ 'STUFF.FROM_NUMBER' | translate }}</span>
                        <span class="tild-text">
                            <input name="start" class="start-end" type="number" [(ngModel)]="option.start" (change)="changeStart(option)" />
                        </span>
                        <span class="tild-text">{{ 'STUFF.AT_NUMBER' | translate }}</span>
                        <span class="tild-text">
                            <input name="end" class="start-end" type="number" [(ngModel)]="option.end" (change)="changeEnd(option)" />
                        </span>
                        <ui-icon-button iconName="remove" size="small" (click)="deleteRange(option)" />
                    </div>
                }
                @if (this.steps[4].options.length < 10) {
                    <button ui-button color="primary" class="small-margin-top" (click)="addRange()">
                        {{ 'IPE.ADD_RANGE' | translate }}
                    </button>
                }
            </div>
        }
        <!-- Define range -->
        @if (rangeChoicesSelected === rangeChoices.yearsRanges) {
            <ng-container [formGroup]="defineRangesForm">
                <!--Reference year -->
                <div class="card-select">
                    <ui-form-field [label]="'IPE.REFERENCE_YEAR' | translate">
                        <ui-select
                            formControlName="referenceYear"
                            valueField="value"
                            labelField="label"
                            [options]="referenceYearsOptions"
                            [multiple]="false"
                            [disabled]="!referenceYearsOptions.length"
                            [(ngModel)]="tile.description.referenceYear"
                            (ngModelChange)="updateReferenceRanges()"
                        />
                    </ui-form-field>
                    @if (!referenceYearsOptions.length) {
                        <div class="text-failure">
                            {{ 'ERRORS.FORM.REFERENCE_YEAR' | translate }}
                        </div>
                    }
                </div>
                <!--Target year-->
                <div class="card-select">
                    <div class="grid-container grid-1">
                        <ui-form-field [label]="'IPE.TARGET_YEAR' | translate">
                            <input
                                advizeoInput
                                type="number"
                                formControlName="targetYear"
                                [required]="true"
                                [(ngModel)]="tile.description.targetYear"
                                (blur)="updateReferenceRanges()"
                            />
                            <ui-form-error errorCode="required">
                                {{ 'ERRORS.FORM.REQUIRED' | translate }}
                            </ui-form-error>
                            <ui-form-error errorCode="minMaxValueError">
                                {{ defineRangesForm.get('targetYear').errors?.minMaxValueError | translate }}
                            </ui-form-error>
                            <ui-form-error errorCode="pattern">
                                {{ 'ERRORS.FORM.INVALID' | translate }}
                            </ui-form-error>
                        </ui-form-field>
                        <ui-form-field [label]="'IPE.TARGET_YEAR_RATIO' | translate">
                            <input
                                advizeoInput
                                type="number"
                                formControlName="targetYearRatio"
                                [required]="true"
                                [(ngModel)]="tile.description.targetYearRatio"
                                (blur)="updateReferenceRanges()"
                            />
                            <ui-form-error errorCode="required">
                                {{ 'ERRORS.FORM.REQUIRED' | translate }}
                            </ui-form-error>
                            <ui-form-error errorCode="minMaxValueError">
                                {{ defineRangesForm.get('targetYearRatio').errors?.minMaxValueError | translate }}
                            </ui-form-error>
                        </ui-form-field>
                    </div>
                </div>
            </ng-container>
        }
    </div>
}

<!-- STEP 4: Get full preview -->
@if (currentStep === 4) {
    <div class="step-content">
        <div class="title">
            <h2>{{ steps[5].title | translate }}</h2>
            <progress class="progress-select" max="100" form="form-id" [value]="steps[5].percentage">{{ steps[5].percentage }}%</progress>
        </div>
        <div class="card-select">
            @if (needsValuePreview(tile)) {
                <tile-ipe-value-sub-component [forceBinding]="forceBinding" [tileData]="tile" [hasTileAdminOption]="false" />
            }
            @if (needsGaugePreview(tile)) {
                <tile-ipe-gauge-sub-component [forceBinding]="forceBinding" [tileData]="tile" [hasTileAdminOption]="false" />
            }
        </div>
    </div>
}

<div class="footer">
    <div class="advizeo-toolbar toolbar-center">
        @if (currentStep !== 0) {
            <button ui-button slot="start" color="primary" buttonStyle="outline" (click)="currentStep = currentStep - 1">
                {{ 'IPE.RETURN' | translate }}
            </button>
        }
        <!--Next Step-->
        @if (currentStep + 2 !== nbSteps && currentStep !== 0) {
            <button
                ui-button
                slot="end"
                color="primary"
                [disabled]="currentStep === 3 && !defineRangesForm.valid && tile.description.yearsRanges"
                (click)="nextStep()"
            >
                {{ 'IPE.NEXT' | translate }}
            </button>
        }
        @if (currentStep + 2 === nbSteps && !editMode) {
            <button ui-button slot="end" color="primary" (click)="createTile()">
                {{ 'IPE.CREATE_TILE' | translate }}
            </button>
        }
        @if (currentStep + 2 === nbSteps && editMode) {
            <button ui-button slot="end" color="primary" (click)="editTile()">
                {{ 'IPE.EDIT_TILE' | translate }}
            </button>
        }
    </div>
</div>
